<template>
  <div class="category-highlight">
    <div class="group__title flex items-center">
      <h2 class="title flex-1">
        {{ category.title }}
      </h2>
    </div>
    <Highlight ref="highlightRef" class="w-full ml-[-8px]" />
  </div>
</template>
<script lang="ts" setup>
import Highlight from '~/components/content/highlight/index.vue';
import type { IHelpCategory } from '~/api/module/help-center';

defineProps<{
  category: IHelpCategory;
}>();

const highlightRef = ref<InstanceType<typeof Highlight>>();
</script>

<style lang="scss" scoped>
.group {
  &__title {
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
